import { displayToast, initializeModals, sendAppsignalError } from "../modules/utils";

export default class CheckboxForm {
  constructor(node) {
    this.element = node;

    this.checkboxes = this.element.querySelectorAll("input[type='checkbox']");
    this.checkboxDestroyButtons = this.element.querySelectorAll(".js-checkbox-destroy");

    this.otherTargets = this.element.dataset.formTargets;
    this.url = new URL(this.element.action, window.location.origin);

    this.initialize();
  }

  initialize() {
    this.otherTargets = this.otherTargets.split(",").map((target) => {
      return document.getElementById(target);
    });

    this.checkboxes.forEach((checkbox) => {
      checkbox.addEventListener("change", () => {
        this.updateCheckbox(new FormData(this.element));
      });
    });

    this.checkboxDestroyButtons.forEach((destroyButton) => {
      destroyButton.addEventListener("click", (e) => {
        const formData = new FormData();
        formData.append(this.element.dataset.fieldName, e.target.dataset.checkboxId);
        this.updateCheckbox(formData, "DELETE");
      });
    });
  }

  updateCheckbox(formData, method = "POST") {
    this.element.classList.add("is-loading");

    this.otherTargets.forEach((target) => {
      target.classList.add("is-loading");
    });

    fetch(this.url, {
      method: method,
      body: formData,
    })
      .then(async (response) => {
        this.response = response;

        if (response.status === 200) {
          return response.json().catch(() => null);
        }

        throw new Error("Something went wrong");
      })
      .then((data) => {
        window.dispatchEvent(new CustomEvent("checkboxForm:updated", { detail: data }));
      })
      .catch((e) => {
        this.checkboxes.forEach((checkbox) => {
          checkbox.checked = false;
        });

        console.error(e);
        displayToast(this.element.dataset.errorMessage);
        sendAppsignalError(e, "CheckboxForm", {
          response: this.response,
        });
      })
      .finally(() => {
        this.element.classList.remove("is-loading");

        this.otherTargets.forEach((target) => {
          target.classList.remove("is-loading");
        });
      });
  }
}
